import { render } from "./MyActionSummaryWidget.vue?vue&type=template&id=93929af6&scoped=true"
import script from "./MyActionSummaryWidget.vue?vue&type=script&lang=js"
export * from "./MyActionSummaryWidget.vue?vue&type=script&lang=js"

import "./my-action-summary-widget.scss?vue&type=style&index=0&id=93929af6&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93929af6"]])

export default __exports__